export const LANGS = [
  { code: "cs", label: "CZ", name: "Čeština" },
  { code: "uk", label: "UA", name: "Українська" },
  { code: "en", label: "EN", name: "English" },
];

export const translations = {
  cs: {
    nav: {
      services: "Služby",
      calculator: "Kalkulačka",
      about: "O nás",
      contact: "Kontakt",
      cta: "Nezávazná konzultace",
    },
    hero: {
      overline: "Hypoteční & realitní poradenství · Brno",
      title_1: "Hypotéka",
      title_em: "bez",
      title_2: "stresu a\u00a0papírování.",
      subtitle:
        "Srovnáme nabídky napříč všemi bankami a\u00a0dohodneme podmínky, které bankovní pobočka sama nenabídne. Od prvního bydlení po komerční financování.",
      cta_calc: "Spočítat splátku",
      cta_contact: "Mluvit s poradcem",
      rates_overline: "Aktuální sazby",
      rates_value_prefix: "od",
      rates_note_suffix: (fix, month) =>
        `p.a. s ${fix}letou fixací${month ? ` · ${month}` : ""}`,
      rates_source_prefix: "zdroj:",
      trust: "Nezávislý poradce. Pracujeme pro vás, ne pro banku.",
      stat_banks: "Partnerských bank",
      stat_volume: "Sjednáno pro klienty",
      stat_rating: "Hodnocení klientů",
    },
    services: {
      overline: "Co pro vás uděláme",
      heading_1: "Jeden poradce.",
      heading_em: "Všechny",
      heading_2: "finanční cesty.",
      subtitle:
        "Ať pořizujete první byt, nebo diverzifikujete komerční portfolio — vedeme vás celým procesem. Bez pobočkových front, bez provizních triků.",
      items: {
        "first-home": {
          title: "První bydlení",
          desc: "Kompletní vedení od výběru banky přes odhad až po podpis úvěrové smlouvy. Mladí do 36 let získají výhodnější sazbu.",
        },
        refinance: {
          title: "Refinancování",
          desc: "Analyzujeme stávající smlouvu a vyjednáme nižší sazbu i delší fixaci. Průměrně ušetříme klientům 2 300 Kč měsíčně.",
        },
        investment: {
          title: "Investiční byty",
          desc: "Cash-flow model, LTV strategie a portfoliové financování pro majitele dvou a více nemovitostí.",
        },
        private: {
          title: "Privátní poradenství",
          desc: "Diskrétní zastoupení pro bonitní klientelu. Privátní bankovnictví, strukturované financování, offshore úvěry.",
        },
        commercial: {
          title: "Komerční úvěry",
          desc: "Financování kancelářských, nájemních a developerských projektů. SPV struktury, mezzanine financování.",
        },
      },
    },
    calc: {
      overline: "Hypoteční kalkulačka",
      heading_1: "Kolik vás bude",
      heading_em: "hypotéka",
      heading_2: "reálně stát?",
      subtitle:
        "Orientační propočet měsíční anuitní splátky. Reálnou nabídku vám po konzultaci ušijeme na míru u konkrétní banky.",
      savings_label: "Průměrná úspora s\u00a0námi",
      savings_value: "357 000 Kč",
      savings_note: "za 5letou fixaci oproti běžné pobočkové nabídce.",
      amount: "Výše úvěru",
      rate: "Úroková sazba",
      years: "Doba splatnosti",
      years_unit: (n) => `${n} ${n === 1 ? "rok" : n < 5 ? "roky" : "let"}`,
      monthly: "Měsíční splátka",
      total: "Celkem zaplatíte",
      interest: "Přeplatek na úrocích",
      cta: "Chci nabídku na míru",
    },
    about: {
      overline: "O nás",
      heading_1: "od roku 2019",
      heading_em: "na vaší straně",
      heading_2: "stolu",
      subtitle:
        "Jsme malý tým zkušených hypotečních specialistů. Nepracujeme pro žádnou banku — pracujeme pro vás. Díky tomu můžeme doporučit to, co se vyplatí, ne to, co má zrovna nejvyšší provizi.",
      bullets: [
        "Nezávislý srovnávač 10+ bank — nikoliv zaměstnanec jediné",
        "Veškerá komunikace s bankou i katastrem za vás",
        "Elektronický podpis, žádné fronty ani přepážky",
        "Fixace a refix hlídáme i po uzavření smlouvy",
      ],
      badge_overline: "Motto",
      badge_quote:
        "Cesta k vlastnímu bydlení je dlouhodobý projekt, nikoli okamžitý výsledek. Základem je mít na své straně správné lidi.",
    },
    contact: {
      overline: "Kontakt",
      heading_1: "Pojďme si",
      heading_em: "nezávazně",
      heading_2: "promluvit.",
      subtitle:
        "Zanechte nám kontakt — ozveme se obvykle do jednoho pracovního dne. Konzultace je zdarma a nic vás k ničemu nezavazuje.",
      email_label: "E-mail",
      phone_label: "Telefon",
      address_label: "Kancelář",
      address_value: "Banskobystrická 265/185, Brno 621 00",
      form: {
        name: "Jméno a příjmení *",
        name_placeholder: "Jan Novák",
        email: "E-mail *",
        email_placeholder: "jan@email.cz",
        phone: "Telefon",
        phone_placeholder: "+420 ...",
        service: "Oblast zájmu",
        service_placeholder: "— Vyberte —",
        message: "Zpráva",
        message_placeholder: "S čím vám můžeme pomoct?",
        gdpr:
          "Odesláním souhlasíte se zpracováním osobních údajů pro účely kontaktování. Žádný spam.",
        submit: "Odeslat poptávku",
        submitting: "Odesílám...",
        error_required: "Vyplňte prosím jméno a e-mail.",
        error_generic: "Odeslání se nepodařilo. Zkuste to prosím znovu.",
        success: "Děkujeme! Ozveme se do 24 hodin.",
      },
      services_list: [
        "První bydlení",
        "Refinancování",
        "Investiční byty",
        "Privátní poradenství",
        "Komerční úvěry",
      ],
    },
    footer: {
      headline_1: "Připraveni na",
      headline_em: "první krok",
      headline_q: "?",
      cta: "Domluvit konzultaci",
      nav: "Navigace",
      contact: "Kontakt",
      rights: (y) =>
        `© ${y} dbrinvest.cz — Hypoteční a realitní poradenství. Vše uvedené má informativní charakter.`,
      gdpr: "GDPR",
      terms: "Obchodní podmínky",
    },
  },

  uk: {
    nav: {
      services: "Послуги",
      calculator: "Калькулятор",
      about: "Про нас",
      contact: "Контакти",
      cta: "Безкоштовна консультація",
    },
    hero: {
      overline: "Іпотечне та ріелторське консультування · Брно",
      title_1: "Іпотека",
      title_em: "без",
      title_2: "стресу та\u00a0паперової тяганини.",
      subtitle:
        "Порівняємо пропозиції в\u00a0усіх банках і\u00a0домовимося про умови, яких сама філія банку не запропонує. Від першого житла до комерційного фінансування.",
      cta_calc: "Розрахувати платіж",
      cta_contact: "Поговорити з радником",
      rates_overline: "Актуальні ставки",
      rates_value_prefix: "від",
      rates_note_suffix: (fix, month) =>
        `річних з ${fix}-річною фіксацією${month ? ` · ${month}` : ""}`,
      rates_source_prefix: "джерело:",
      trust: "Незалежний радник. Працюємо для вас, а не для банку.",
      stat_banks: "Банків-партнерів",
      stat_volume: "Оформлено клієнтам",
      stat_rating: "Оцінка клієнтів",
    },
    services: {
      overline: "Що ми для вас зробимо",
      heading_1: "Один радник.",
      heading_em: "Усі",
      heading_2: "фінансові шляхи.",
      subtitle:
        "Купуєте першу квартиру чи диверсифікуєте комерційне портфоліо — супроводжуємо вас на кожному кроці. Без черг у філії, без прихованих комісій.",
      items: {
        "first-home": {
          title: "Перше житло",
          desc: "Повний супровід — від вибору банку та оцінки нерухомості до підписання кредитного договору. Молодь до 36 років отримує вигіднішу ставку.",
        },
        refinance: {
          title: "Рефінансування",
          desc: "Проаналізуємо чинний договір і домовимося про нижчу ставку й довшу фіксацію. У середньому клієнти економлять 2 300 Kč на місяць.",
        },
        investment: {
          title: "Інвестиційне житло",
          desc: "Cash-flow модель, LTV-стратегія та портфельне фінансування для власників двох і більше об'єктів.",
        },
        private: {
          title: "Приватне консультування",
          desc: "Дискретне представництво для заможних клієнтів. Приватний банкінг, структуроване фінансування, офшорні кредити.",
        },
        commercial: {
          title: "Комерційні кредити",
          desc: "Фінансування офісних, орендних та девелоперських проєктів. SPV-структури, мезонінне фінансування.",
        },
      },
    },
    calc: {
      overline: "Іпотечний калькулятор",
      heading_1: "Скільки вам реально",
      heading_em: "коштуватиме",
      heading_2: "іпотека?",
      subtitle:
        "Орієнтовний розрахунок щомісячного ануїтетного платежу. Після консультації підготуємо реальну пропозицію в конкретному банку.",
      savings_label: "Середня економія з\u00a0нами",
      savings_value: "357 000 Kč",
      savings_note:
        "за 5-річну фіксацію порівняно зі звичайною пропозицією філії.",
      amount: "Сума кредиту",
      rate: "Процентна ставка",
      years: "Строк погашення",
      years_unit: (n) => {
        const mod10 = n % 10;
        const mod100 = n % 100;
        let word = "років";
        if (mod10 === 1 && mod100 !== 11) word = "рік";
        else if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20))
          word = "роки";
        return `${n} ${word}`;
      },
      monthly: "Щомісячний платіж",
      total: "Загалом сплатите",
      interest: "Переплата за відсотками",
      cta: "Хочу пропозицію на замовлення",
    },
    about: {
      overline: "Про нас",
      heading_1: "з 2019 року",
      heading_em: "на вашому боці",
      heading_2: "столу",
      subtitle:
        "Ми невелика команда досвідчених іпотечних спеціалістів. Не працюємо на жоден банк — працюємо для вас. Тому можемо порадити те, що справді вигідно, а не те, що дає найвищу комісію.",
      bullets: [
        "Незалежний порівнювач 10+ банків — а не співробітник одного",
        "Усю комунікацію з банком і кадастром беремо на себе",
        "Електронний підпис, жодних черг і кас",
        "Стежимо за фіксацією та рефіксацією навіть після укладання договору",
      ],
      badge_overline: "Мотто",
      badge_quote:
        "Шлях до власного житла — це довготривалий проєкт, а не миттєвий результат. Найважливіше — мати на своєму боці правильних людей.",
    },
    contact: {
      overline: "Контакти",
      heading_1: "Поговорімо",
      heading_em: "без зобов'язань",
      heading_2: ".",
      subtitle:
        "Залиште контакт — зазвичай відповідаємо протягом одного робочого дня. Консультація безкоштовна й ні до чого вас не зобов'язує.",
      email_label: "E-mail",
      phone_label: "Телефон",
      address_label: "Офіс",
      address_value: "Banskobystrická 265/185, Брно 621 00",
      form: {
        name: "Ім'я та прізвище *",
        name_placeholder: "Іван Коваленко",
        email: "E-mail *",
        email_placeholder: "ivan@email.cz",
        phone: "Телефон",
        phone_placeholder: "+420 ...",
        service: "Сфера інтересу",
        service_placeholder: "— Оберіть —",
        message: "Повідомлення",
        message_placeholder: "Чим можемо допомогти?",
        gdpr:
          "Надсиланням ви погоджуєтеся з обробкою персональних даних для цілей зворотного зв'язку. Без спаму.",
        submit: "Надіслати запит",
        submitting: "Надсилаю...",
        error_required: "Будь ласка, заповніть ім'я та e-mail.",
        error_generic: "Не вдалося надіслати. Спробуйте ще раз.",
        success: "Дякуємо! Зв'яжемося з вами протягом 24 годин.",
      },
      services_list: [
        "Перше житло",
        "Рефінансування",
        "Інвестиційне житло",
        "Приватне консультування",
        "Комерційні кредити",
      ],
    },
    footer: {
      headline_1: "Готові зробити",
      headline_em: "перший крок",
      headline_q: "?",
      cta: "Замовити консультацію",
      nav: "Навігація",
      contact: "Контакти",
      rights: (y) =>
        `© ${y} dbrinvest.cz — Іпотечне та ріелторське консультування. Усе викладене має інформативний характер.`,
      gdpr: "GDPR",
      terms: "Умови користування",
    },
  },

  en: {
    nav: {
      services: "Services",
      calculator: "Calculator",
      about: "About",
      contact: "Contact",
      cta: "Free consultation",
    },
    hero: {
      overline: "Mortgage & real-estate advisory · Brno",
      title_1: "A mortgage",
      title_em: "without",
      title_2: "stress or paperwork.",
      subtitle:
        "We compare offers across all banks and negotiate terms the branch would never give you directly. From first-time buyers to commercial financing.",
      cta_calc: "Calculate payment",
      cta_contact: "Talk to an advisor",
      rates_overline: "Current rates",
      rates_value_prefix: "from",
      rates_note_suffix: (fix, month) =>
        `p.a. with ${fix}-year fixation${month ? ` · ${month}` : ""}`,
      rates_source_prefix: "source:",
      trust: "Independent advisor. We work for you, not the bank.",
      stat_banks: "Partner banks",
      stat_volume: "Arranged for clients",
      stat_rating: "Client rating",
    },
    services: {
      overline: "What we do for you",
      heading_1: "One advisor.",
      heading_em: "Every",
      heading_2: "financial path.",
      subtitle:
        "Whether you're buying your first flat or diversifying a commercial portfolio — we guide you end-to-end. No branch queues, no commission tricks.",
      items: {
        "first-home": {
          title: "First-time buyers",
          desc: "Full guidance from bank selection through appraisal to signing the loan agreement. Buyers under 36 get a preferential rate.",
        },
        refinance: {
          title: "Refinancing",
          desc: "We analyse your current contract and negotiate a lower rate and longer fixation. Our clients save 2,300 Kč a month on average.",
        },
        investment: {
          title: "Investment property",
          desc: "Cash-flow modelling, LTV strategy and portfolio financing for owners of two or more properties.",
        },
        private: {
          title: "Private advisory",
          desc: "Discreet representation for high-net-worth clients. Private banking, structured financing, offshore loans.",
        },
        commercial: {
          title: "Commercial loans",
          desc: "Financing for office, rental and development projects. SPV structures, mezzanine financing.",
        },
      },
    },
    calc: {
      overline: "Mortgage calculator",
      heading_1: "How much will your",
      heading_em: "mortgage",
      heading_2: "actually cost?",
      subtitle:
        "An indicative annuity-payment estimate. After a consultation we'll tailor a real offer with a specific bank.",
      savings_label: "Average savings with\u00a0us",
      savings_value: "357 000 Kč",
      savings_note: "on a 5-year fixation vs. a standard branch offer.",
      amount: "Loan amount",
      rate: "Interest rate",
      years: "Term",
      years_unit: (n) => `${n} ${n === 1 ? "year" : "years"}`,
      monthly: "Monthly payment",
      total: "Total to repay",
      interest: "Interest overpaid",
      cta: "Get a tailored offer",
    },
    about: {
      overline: "About us",
      heading_1: "Since 2019",
      heading_em: "on your side",
      heading_2: "of the table",
      subtitle:
        "We're a small team of experienced mortgage specialists. We don't work for any bank — we work for you. That lets us recommend what actually pays off, not what carries the highest commission.",
      bullets: [
        "Independent comparison across 10+ banks — not an employee of one",
        "We handle all communication with the bank and land registry",
        "E-signatures — no queues, no counters",
        "We monitor your fixation and refix even after signing",
      ],
      badge_overline: "Motto",
      badge_quote:
        "The journey to your own home is a long-term project, not an instant result. What matters most is having the right people on your side.",
    },
    contact: {
      overline: "Contact",
      heading_1: "Let's have a",
      heading_em: "no-obligation",
      heading_2: "chat.",
      subtitle:
        "Drop us your details — we usually reply within one working day. The consultation is free and commits you to nothing.",
      email_label: "E-mail",
      phone_label: "Phone",
      address_label: "Office",
      address_value: "Banskobystrická 265/185, Brno 621 00",
      form: {
        name: "Full name *",
        name_placeholder: "John Smith",
        email: "E-mail *",
        email_placeholder: "john@email.com",
        phone: "Phone",
        phone_placeholder: "+420 ...",
        service: "Area of interest",
        service_placeholder: "— Select —",
        message: "Message",
        message_placeholder: "How can we help?",
        gdpr:
          "By submitting you agree to the processing of personal data for contact purposes. No spam.",
        submit: "Send enquiry",
        submitting: "Sending...",
        error_required: "Please fill in your name and e-mail.",
        error_generic: "Submission failed. Please try again.",
        success: "Thank you! We'll be in touch within 24 hours.",
      },
      services_list: [
        "First-time buyers",
        "Refinancing",
        "Investment property",
        "Private advisory",
        "Commercial loans",
      ],
    },
    footer: {
      headline_1: "Ready for the",
      headline_em: "first step",
      headline_q: "?",
      cta: "Book a consultation",
      nav: "Navigation",
      contact: "Contact",
      rights: (y) =>
        `© ${y} dbrinvest.cz — Mortgage and real-estate advisory. All information provided is indicative.`,
      gdpr: "GDPR",
      terms: "Terms of use",
    },
  },
};
